import { SvgIcon } from "@cmsgov/ds-medicare-gov";
import { IconCommonProps } from "@cmsgov/design-system/dist/react-components/types/Icons/SvgIcon";
import React from "react";

const defaultProps = {
  className: "",
  title: "reminder",
  viewBox: "0 0 29 40",
};

function HomeIcon(props: IconCommonProps): React.ReactElement {
  const iconCssClasses = `mct-c-icon--reminder ${props.className || ""}`;

  return (
    <SvgIcon {...defaultProps} {...props} className={iconCssClasses}>
      <defs>
        <polygon
          id="path-1"
          points="0 0.584034211 28.0526316 0.584034211 28.0526316 32.3684211 0 32.3684211"
        />
        <polygon
          id="path-3"
          points="0.683621053 0.298868421 20.3150684 0.298868421 20.3150684 19.0886289 0.683621053 19.0886289"
        />
      </defs>
      <g
        id="Leadership-feedback-round-2-July-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Year-to-year---Full-page"
          transform="translate(-120.000000, -4417.000000)"
        >
          <g
            id="ALT-PLAN-CALLOUT"
            transform="translate(77.000000, 4380.000000)"
          >
            <g id="Group-4" transform="translate(20.000000, 21.000000)">
              <g
                id="Icons/Get-started"
                transform="translate(23.406250, 15.000000)"
              >
                <g id="getbasics" transform="translate(-0.000000, 0.000000)">
                  <g
                    id="Fill-1-Clipped"
                    transform="translate(0.000000, 8.332171)"
                  >
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1" />
                    </mask>
                    <g id="path-1" />
                    <path
                      d="M2.62443158,19.8119553 C1.99648421,19.8119553 1.42356316,19.9069026 0.967168421,20.0870868 C0.396405263,20.3115079 0.0457473684,20.63735 0.00582631579,20.9826132 C-0.0308578947,21.2944289 0.0845894737,21.9007974 0.749221053,22.1942711 C4.94848421,24.0565342 7.37935263,28.3097447 8.22956316,30.0533237 C8.91577368,31.4591921 10.3712737,32.3687447 11.9379053,32.3687447 L23.3736684,32.3687447 C25.4409316,32.3687447 27.1543,30.8808763 27.4477737,28.8297974 C28.3174053,22.7574816 27.9948,15.2814553 27.9915632,15.2070079 C27.9915632,15.1962184 27.9904842,15.18435 27.9904842,15.1735605 C27.9904842,14.7365868 27.8815105,13.2929553 26.4767211,13.0836395 C26.0127737,13.0135079 25.5499053,13.2001658 25.1981684,13.5939816 C24.8917474,13.9370868 24.7158789,14.38485 24.7158789,14.8218237 L24.7158789,16.6420079 C24.7158789,17.0509289 24.3846421,17.3821658 23.9757211,17.3821658 L23.8689053,17.3821658 C23.4610632,17.3821658 23.1287474,17.0509289 23.1287474,16.6420079 L23.1287474,12.8505868 C23.1287474,11.8967974 22.2904053,11.1199553 21.2589316,11.1199553 C20.2263789,11.1199553 19.3869579,11.8967974 19.3869579,12.8505868 L19.3869579,16.1931658 C19.3869579,16.6010079 19.0557211,16.9333237 18.6489579,16.9333237 L18.5410632,16.9333237 C18.3436158,16.9333237 18.1569579,16.8556395 18.0177737,16.7164553 C17.8785895,16.57835 17.7998263,16.3895342 17.7998263,16.1931658 L17.7998263,11.0670868 C17.7998263,10.1132974 16.9604053,9.33645526 15.9300105,9.33645526 C14.8985368,9.33645526 14.0591158,10.1132974 14.0591158,11.0670868 L14.0591158,15.7443237 C14.0591158,16.1532447 13.7278789,16.4844816 13.3189579,16.4844816 L13.2650105,16.4844816 C12.8582474,16.4844816 12.5291684,16.1564816 12.5248526,15.7497184 L12.4191158,2.56821842 C12.4191158,2.06003421 12.2227474,1.55508684 11.8818,1.17637632 C11.5376158,0.794428947 11.0833789,0.584034211 10.6021684,0.584034211 C9.50056316,0.584034211 8.67732632,1.64356053 8.67732632,2.59087632 L8.67732632,17.2731921 C8.67732632,17.2904553 8.67624737,17.3066395 8.67516842,17.3228237 L8.67516842,20.92435 C8.67516842,21.2242974 8.49498421,21.4940342 8.21877368,21.6084026 C7.94148421,21.7227711 7.62319474,21.6591132 7.41172105,21.4476395 C6.4493,20.4841395 4.11661579,19.8119553 2.62443158,19.8119553"
                      id="Fill-1"
                      fill="#1E3C70"
                      fillRule="nonzero"
                      mask="url(#mask-2)"
                    />
                  </g>
                  <path
                    d="M10.4994526,4.80347368 C7.14176842,4.80347368 4.40771579,7.53644737 4.40771579,10.8952105 C4.40771579,12.7348158 5.22879474,14.3866842 6.52353158,15.5044737 L6.52353158,13.2235789 C6.12108421,12.5395263 5.89018947,11.7443421 5.89018947,10.8952105 C5.89018947,8.35321053 7.95853158,6.28486842 10.4994526,6.28486842 C13.0414526,6.28486842 15.1097947,8.35321053 15.1097947,10.8952105 C15.1097947,11.6601842 14.9220579,12.382 14.5897421,13.0175 L14.6091632,15.3868684 C15.8262158,14.2723158 16.5911895,12.6711579 16.5911895,10.8952105 C16.5911895,7.53644737 13.8582158,4.80347368 10.4994526,4.80347368"
                    id="Fill-4"
                    fill="#1E3C70"
                    fillRule="nonzero"
                  />
                  <g
                    id="Fill-6-Clipped"
                    transform="translate(0.000000, 0.779539)"
                  >
                    <mask id="mask-4" fill="white">
                      <use xlinkHref="#path-3" />
                    </mask>
                    <g id="path-3" />
                    <path
                      d="M6.52396316,19.0886289 L6.52396316,17.4389184 C3.92909474,16.0244184 2.16501579,13.2720237 2.16501579,10.1150237 C2.16501579,5.51870789 5.90356842,1.78015526 10.4998842,1.78015526 C15.0951211,1.78015526 18.8347526,5.51870789 18.8347526,10.1150237 C18.8347526,11.9201026 18.2575158,13.5924711 17.2789105,14.9584184 C17.7579632,15.1213395 18.1960158,15.3705763 18.5747263,15.6888658 C19.6720158,14.1038921 20.3150684,12.1833658 20.3150684,10.1150237 C20.3150684,4.70302368 15.9118842,0.298760526 10.4998842,0.298760526 C5.08680526,0.298760526 0.683621053,4.70302368 0.683621053,10.1150237 C0.683621053,14.1125237 3.08643684,17.5597605 6.52396316,19.0886289"
                      id="Fill-6"
                      fill="#1E3C70"
                      fillRule="nonzero"
                      mask="url(#mask-4)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default HomeIcon;
